import { TiLocale } from "../types";
const getFirstPath = (menu, deep = 1) => {
  var _a;
  if (!menu) {
    return "/";
  }
  if (((_a = menu.children) == null ? void 0 : _a.length) > 0 && deep === 1) {
    return getFirstPath(menu.children[0], deep + 1);
  }
  return menu.path;
};
const translateMenu = (menu, locale) => {
  menu == null ? void 0 : menu.forEach((item) => {
    item.name = locale === TiLocale.EN_US ? item.ename : item.cname;
    if (item.children) {
      translateMenu(item.children, locale);
    }
  });
};
export {
  getFirstPath,
  translateMenu
};
